import PropTypes from 'prop-types'
import React from 'react'
import Base from './BaseContainer'
import { connect } from 'react-redux'

import HeaderComponent from '../components/Header/Header'
import Constants from '../services/constants/Constants'

import { fetchLogoutAction } from '../services/ws/AuthWS'
import { clearAppsFromStoreAction, fetchAppsAction, saveAppActions } from '../services/ws/AppWS'
import { loading } from '../services/manager/HttpManager'
import axios from 'axios'
import { withRouter } from 'react-router-dom'

class Header extends Base {

  constructor(props) {
    super(props)
    this._bind('_handleSearch', '_handleGoHome', '_handleGoMyAccount',
      '_handleGoMyTeam', '_handleGoMySettings', '_handleLogout', '_handleRefresh',
      '_handleChangeTeam', '_handleGoAdmin', '_handleShowFAQ',
      '_handleHelp', '_handleHelpEnd', '_handleMissingHelp'
    )
    this.state = {
      helpShown: false,
      releaseNoteShow: false,
      releaseNoteList: null,
      releaseNoteSelected: null,
    }
  }
  componentDidMount() {
    // console.log(localStorage.getItem('sw_release_note_last_seen'))
    if (localStorage.getItem('sw_release_note_last_seen')) {
      axios.get('https://release-note.swizi.io/list').then(res => {
        let list = res.data
        if (list.length) {
          list = list.sort((a, b) => {
            if (a.timestamp > b.timestamp) return -1
            else return 1
          })
          let selectedNote = list[0]
          // console.log(selectedNote.timestamp)
          // console.log(localStorage.getItem('sw_release_note_last_seen'))
          // console.log('' + selectedNote.timestamp === localStorage.getItem('sw_release_note_last_seen'))
          if ('' + selectedNote.timestamp === localStorage.getItem('sw_release_note_last_seen')) {
            // do nothing, has already seen the note
          } else {
            // console.log(localStorage.getItem('sw_release_note_hide'))
            localStorage.setItem('sw_release_note_last_seen', selectedNote.timestamp)
            if (!localStorage.getItem('sw_release_note_hide')) {
              setTimeout(() => this.setState({
                releaseNoteShow: true,
                releaseNoteList: list,
                releaseNoteSelected: selectedNote.id,
              }), 1500)
            }
          }
        }
      })
    } else {
      if (!localStorage.getItem('sw_release_note_hide')) {
        setTimeout(() => this.setState({ releaseNoteShow: true }), 1500)
      }
    }
  }
  componentDidUpdate() {
    if (localStorage.getItem('coach')) {
      let alreadySeenCoachmark = JSON.parse(localStorage.getItem('coach'))
      if (alreadySeenCoachmark.indexOf(this.props.location.pathname) === -1) {
        if (this.state.helpShown === false) {
          this._handleHelp()
          alreadySeenCoachmark.push(this.props.location.pathname)
          localStorage.setItem('coach', JSON.stringify(alreadySeenCoachmark))
        }
      }
    }
  }

  _handleSearch(event) {
  }

  _handleShowFAQ() {
    window.open(Constants.UrlsConstants.faqUrl, '_blank')
  }

  handleShowReleaseNote = () => {
    this.setState({ releaseNoteShow: true })
  }

  _handleChangeTeam(event) {
    // Clear current app data
    this.props.clearApp()
    // Clear all list of app
    this.props.clearApps()
    let mailOwner = event.currentTarget.getAttribute('data-linkid')
    // Refresh all the app of user
    this.props.fetchApps(mailOwner)
  }

  _handleGoHome() {
    var currentRouteName = this.props.location.pathname
    this._handleHelpEnd()
    if (currentRouteName !== '/') {
      this.props.clearApp()
      this.props.clearApps()
      this.props.fetchApps(this.props.user.email)
      this.props.history.push(Constants.RoutesConstants.root)
    }
  }

  _handleGoMyAccount() {
    // console.log('Go to my account')
    this.props.history.push('/' + Constants.RoutesConstants.account.account)
    this._handleHelpEnd()
  }

  _handleGoMyTeam(event) {
    // console.log('Go to my team')
    this.props.history.push('/' + Constants.RoutesConstants.account.account + '/' +
      Constants.RoutesConstants.account.myteam)
    this._handleHelpEnd()
  }

  _handleGoMySettings(event) {
    // console.log('Go to my settings')
    this.props.history.push('/' + Constants.RoutesConstants.account.account + '/' +
      Constants.RoutesConstants.account.mysettings)
    this._handleHelpEnd()
  }

  _handleGoAdmin(event) {
    this.props.history.push('/' + Constants.RoutesConstants.admin.admin + '/' +
      Constants.RoutesConstants.admin.users)
    this._handleHelpEnd()
  }

  _handleLogout(event) {
    // Call Ws to disconnect
    this.props.logoutUser()
    // Clear local value
    localStorage.removeItem('selectedMenuItem')
    // Return to welcome screen
    window.location.href = '/'
  }

  _handleRefresh() {
    this.props.refreshApp(this.props.app.id)
  }

  _handleHelp() {
    if (this.state.helpShown) {
      this._handleHelpEnd()
    } else {
      this.setState({ helpShown: true })
    }
  }

  _handleHelpEnd() {
    this.setState({ helpShown: false })
  }

  _handleMissingHelp() {
    this.props.dispatch(loading('Error.Croutons.missingHelp'))
    this._handleHelpEnd()
  }
  handleCloseShow = () => {
    this.setState({ releaseNoteShow: false })
  }
  render() {
    return (
      <HeaderComponent
        isMenuOpened={this.props.openedMenu}
        isHeaderDisplayed={this.props.fullHeader}
        isHelpDisplayed={this.state.helpShown}
        currentLocale={this.props.locale}
        currentTour={this.props.history && this.props.location.pathname}
        onShowFAQ={this._handleShowFAQ}
        onEndTour={this._handleHelpEnd}
        onHelpClick={this._handleHelp}
        onRefreshClick={this._handleRefresh}
        onMissingHelp={this._handleMissingHelp}
        onLogoClick={this._handleGoHome}
        onMyAccountClick={this._handleGoMyAccount}
        onMyTeamClick={this._handleGoMyTeam}
        isTeamDisplayed={this.props.teamDisplayed}
        isRefreshDisplayed={this.props.refreshDisplayed}
        onMySettingsClick={this._handleGoMySettings}
        onLogoutClick={this._handleLogout}
        onSearch={this._handleSearch}
        onChangeTeamClick={this._handleChangeTeam}
        onAdmin={this._handleGoAdmin}
        user={this.props.user}
        releaseNoteShow={this.state.releaseNoteShow}
        handleShowReleaseNote={this.handleShowReleaseNote}
        releaseNoteList={this.state.releaseNoteList}
        releaseNoteSelected={this.state.releaseNoteSelected}
        handleCloseShow={this.handleCloseShow}
        app={this.props.app}
      />
    )
  }

}

Header.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object,
  openedMenu: PropTypes.bool.isRequired,
  logoutUser: PropTypes.func.isRequired,
  fullHeader: PropTypes.bool.isRequired,
  apps: PropTypes.array.isRequired,
  app: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  teamDisplayed: PropTypes.bool.isRequired,
  refreshDisplayed: PropTypes.bool.isRequired,
  // clearApp: React.PropTypes.func.isRequired,
}

const mapStateToProps = ({ appWS: { apps, app }, authWS: { user }, i18n: { locale } }) => ({
  apps,
  app,
  user,
  locale,
})

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  logoutUser() {
    fetchLogoutAction(dispatch).fetchLogout()
  },
  clearApp() {
    clearAppsFromStoreAction(dispatch).clearAppFromStore()
  },
  clearApps() {
    clearAppsFromStoreAction(dispatch).clearAppsFromStore()
  },
  fetchApps(teamOwner) {
    fetchAppsAction(dispatch, null, null, null, teamOwner).fetchApps()
  },
  refreshApp(appId) {
    saveAppActions(dispatch, null, appId).syncApp()
  },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))
